import { axiosInstance } from "../../../utils/api";

export async function uploadGalleryHdriFile(
    file: File,
    batch: boolean,
    galleryType: string,
    galleryId: string
) {
    const formData = new FormData();
    formData.append("batch", batch ? "1" : "0");
    formData.append("galleryId", galleryId);
    formData.append("types", galleryType);
    formData.append("model", file);

    const resp = await axiosInstance.post("/admin/files/gallery-hdri", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })

    return resp.data;    
}

export async function uploadArtworkModelFile(
    file: File,
    type: string,
    dioramaId: string
) {
    const formData = new FormData()
    formData.append("model", file);
    formData.append("type", type);
    formData.append("batch", "1");
    formData.append("artworkId", dioramaId);

    const resp = await axiosInstance.post("/admin/files/artwork-model", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })

    return resp.data;
}

export async function getDioramaArtworksWithSpaceType() {
    const resp = await axiosInstance.get("/admin/files/artwork-model");
    return resp.data;
}